import gql from 'graphql-tag';
import { editorBlockFragment } from '@/editor/api/graphql/editor-block.fragment';

export class DocumentQueries {
  static documentQuery = gql`
    query Document($documentId: String!) {
      document(documentId: $documentId) {
        id
        name
        status
        isSigning
        isSigningOrder
        isSelfsign
        type
        tags {
          title
          status
          id
        }
        autoCommentText
        autoCommentEmail
        isAutoComment
        isAutoCommentEmail
        value
        contractStartDate
        contractEndDate
        expirationDate
        sendDate
        signDate
        scheduledSendingTime
        isSigningBiometric
        isSigningInitials
        isSigningForward
        isPrivate
        previewUrl
        externalEditorId
        externalEditorType
        uniqueId
        hasWriteAccess
        isSmsReminder
        isReminderSending
        isIdentifyRecipient
        reminderOpened
        reminderOpenedDays
        reminderSigned
        reminderSignedDays
        reminderRepeatDays
        reminderExpiration
        reminderExpirationDays
        user {
          email
          firstName
          lastName
          fullName
          id
          thumbUrl
          title
          mobile
        }
        recipients {
          firstName
          lastName
          fullName
          companyName
          companyNumber
          title
          mobile
          email
          thumbUrl
          gender
          role
          roleName
          id
          orderNum
          verifyQna
          verifyQnaOpen
          verifyQnaSign
          verifyQnaQuestion
          verifyQnaAnswer
          verifySms
          verifySmsOpen
          verifySmsSign
          verifyLinkedin
          verifyEid
          verifyEidType
          createdAt
          phone
          note
          status
          contactId
        }
        video {
          video {
            id
            thumbUrl
            videoUrl
            videoType
          }
        }
        pages {
          id
          pageType
          pageNum
          pageHeight
          pageWidth
          cropBoxH
          cropBoxW
          video {
            id
            thumbUrl
            videoUrl
            videoType
            videoTitle
          }
          contentLinkBlock {
            buttonText
            description
            id
            thumbUrl
            thumbExtension
            title
            url
          }
          editorBlock {
            ...editorBlockFragment
          }
        }
        manuallySignedPages {
          pageWidth
          pageHeight
          pageNum
          thumbUrl
        }
        documentAttachments {
          id
          restrictAccess
          requireView
          createdAt
          previewUrl
          lastView
          lastUpload
          attachment {
            attachmentType
            attachmentTitle
            attachmentDescription
            attachmentUrl
            attachmentFilename
            attachmentSize
            attachmentSha
            thumbUrl
            published
            library
            hashId
          }
          accessRecipientList {
            id
            firstName
            fullName
            lastName
            roleName
          }
        }
        documentRevisions {
          message
          revision
          status
          editorBlockContentVersions {
            blockId
            contentId
            versions {
              versionId
              lastModified
              isLatest
              isPublished
            }
          }
        }
      }
    }
    ${editorBlockFragment}
  `;

  static documentRevisionsQuery = gql`
    query Document($documentId: String!) {
      document(documentId: $documentId) {
        id
        documentRevisions {
          message
          revision
          status
          editorBlockContentVersions {
            blockId
            contentId
            versions {
              versionId
              lastModified
              isLatest
              isPublished
            }
          }
        }
      }
    }
  `;

  static editorRecipientInputQuery = gql`
    query editorRecipientInput($documentId: String!) {
      editorRecipientInput(documentId: $documentId) {
        fieldId
        value
      }
    }
  `;

  static loadDocumentPageQuery = gql`
    query DocumentPage($documentId: String!, $id: String!) {
      documentPage(documentId: $documentId, id: $id) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
      }
    }
  `;

  static documentTrackingQuery = gql`
    query DocumentTracking($documentId: String!) {
      document(documentId: $documentId) {
        id
        clickTrackings: trackClick {
          recipientId
          contentLinkBlockId
          createdAt
        }
        videoTrackings: trackVideo {
          recipientId
          videoId
          viewTime
          viewDuration
        }
        pageTrackings: trackPage {
          id
          recipientId
          pageNum
          pageTime
        }
        visitTrackings: trackVisit {
          recipientId
          visitTime
        }
      }
    }
  `;

  static documentPreviewTokenQuery = gql`
    query previewToken($documentId: String!) {
      previewToken(documentId: $documentId) {
        jwt
        exp
      }
    }
  `;

  static pageThumbUrl = gql`
    query DocumentPageThumbUrl($id: String!, $documentId: String!) {
      documentPage(id: $id, documentId: $documentId) {
        id
        thumbUrl
      }
    }
  `;

  static pageNumQuery = gql`
    query DocumentPageNum($documentId: String!) {
      document(documentId: $documentId) {
        pages {
          id
          pageNum
        }
      }
    }
  `;

  static templateResourceDetailsQuery = gql`
    query TemplateResourceDetails($contentId: String!) {
      document(documentId: $contentId) {
        id
        name
        previewThumbUrl
        externalEditorType
        hasWriteAccess
      }
    }
  `;

  static externalEditorIdQuery = gql`
    query ExternalEditorId($documentId: String!) {
      document(documentId: $documentId) {
        externalEditorId
      }
    }
  `;

  static documentPageQuery = gql`
    query DocumentPages($documentId: String!) {
      document(documentId: $documentId) {
        id
        pages {
          id
          thumbUrl
          pageType
          pageNum
          pageHeight
          pageWidth
          cropBoxH
          cropBoxW
          video {
            id
            thumbUrl
            videoUrl
            status
          }
          contentLinkBlock {
            buttonText
            description
            id
            thumbUrl
            thumbExtension
            title
            url
          }
          editorBlock {
            ...editorBlockFragment
          }
        }
      }
    }
    ${editorBlockFragment}
  `;

  static recipientsQuery = gql`
    query Document($documentId: String!) {
      document(documentId: $documentId) {
        id
        recipients {
          fullName
          mobile
          status
        }
      }
    }
  `;
  static DocumentStatusQuery = gql`
    query DocumentStatus($documentId: String!) {
      document(documentId: $documentId) {
        id
        status
      }
    }
  `;
}
